import { Snapshot } from 'types';
import { Autocomplete, ListItem, TextField } from '@mui/material';
import { NoneSnapshotPlaceholder } from './types';
import { useState } from 'react';

interface Props {
  snapshots?: Snapshot[];
  selectedSnapshotId: number;
  handleSnapshotChanged: (snapshotId: number) => void;
  fullWidth?: boolean;
}

const noneSnapshotPlaceholder: NoneSnapshotPlaceholder = {
  id: -1,
  name: 'None',
};

const SnapshotSelectLocal = ({
  snapshots,
  selectedSnapshotId,
  handleSnapshotChanged,
  fullWidth = false,
}: Props) => {
  const options = snapshots
    ? [noneSnapshotPlaceholder, ...snapshots]
    : [noneSnapshotPlaceholder];

  const handleCallingParentOnChangeMethod = (
    e: React.SyntheticEvent,
    v: Snapshot | NoneSnapshotPlaceholder | null,
    r: any
  ) => {
    // Don't change the selection to None if backspacing out the field
    if (e.type === 'change' && v === null) return;
    // Change to None if selecting None or clearing the field with the X
    if (v === null || v.id === -1) handleSnapshotChanged(-1);
    // Pass the changed ID up to the parent
    else handleSnapshotChanged(v.id);
  };

  // Manually track text input to prevent italization of non-None values
  const [textInput, setTextInput] = useState<string>('');

  return (
    <Autocomplete
      value={
        snapshots?.find((snapshot) => snapshot.id === selectedSnapshotId) ||
        noneSnapshotPlaceholder
      }
      onChange={handleCallingParentOnChangeMethod}
      options={options}
      getOptionLabel={(snapshot) => snapshot.name}
      renderInput={(params) => (
        // Italicize the input only when None is selected
        <TextField
          {...params}
          sx={{
            ...(selectedSnapshotId === -1 &&
              textInput === 'None' && {
                '& .MuiInputBase-input.MuiOutlinedInput-input': {
                  fontStyle: 'italic',
                },
              }),
          }}
          label='Snapshot'
        />
      )}
      onInputChange={(e, v) => setTextInput(v)}
      fullWidth={fullWidth}
      autoHighlight
      // Italicize the None option in the option list
      renderOption={(props, option) => (
        <ListItem {...props} key={option.id}>
          {option.id !== -1 ? option.name : <em>{option.name}</em>}
        </ListItem>
      )}
    />
  );
};

export default SnapshotSelectLocal;
